import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase env vars. Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env');
}

/** Singleton Supabase client — import this everywhere instead of creating a new one. */
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/** Get the current user's profile row from public.users. */
export async function fetchUserProfile(authUser) {
  if (!authUser?.email) return null;
  
  const { data: profile, error } = await supabase
    .from('users')
    .select('*')
    .eq('auth_id', authUser.id)
    .maybeSingle();

  if (error) {
    console.error('fetchUserProfile error:', error.message);
    return null;
  }

  return profile;
}
